import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@/lib/api-client';
export function useMyRequests() {
    return useQuery({
        queryKey: ['student-requests'],
        queryFn: () => apiClient('/requests/me/list'),
        staleTime: 1000 * 60 * 5,
    });
}
export function useCreateRequest() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (dto) => apiClient('/requests', {
            method: 'POST',
            body: JSON.stringify(dto),
        }),
        onSuccess: () => void queryClient.invalidateQueries({ queryKey: ['student-requests'] }),
    });
}
//# sourceMappingURL=useMyRequests.js.map